import React from "react";
import Input from "../common/Input";
import Select from "../common/Select";

function AlabamaIIHS({ data, handleChange, handleSave }) {
  const JSON = {
    contactDate: {
      type: "date",
      label: "Date Contact Made",
      value: "",
    },
    caseOpened: {
      type: "date",
      label: "Date Case Opened",
      value: "",
    },
    region: {
      type: "input",
      label: "Region",
      value: "",
    },
    modality: {
      type: "input",
      label: "Modality",
      value: "",
    },
    caseNumber: {
      type: "input",
      label: "Case Number",
      value: "",
    },
    childLocation: {
      type: "input",
      label: "Where child is at Time of Referral",
      value: "",
    },
  };
  return (
    <>
      <div className="row">
        {/* <div className="col">
          <Input
            type="date"
            name="contactDate"
            label="Date Contact Made"
            onChange={handleChange}
            value={data.DynamicFields.results.contactDate}
          ></Input>
        </div>
        <div className="col">
          <Input
            type="date"
            name="caseOpened"
            label="Date Case Opened"
            onChange={handleChange}
            value={data.DynamicFields.results.caseOpened}
          ></Input>
        </div> */}
        <div className="col">
          <Select
            name="caseType"
            label="Case Type"
            onChange={handleChange}
            options={[
              {
                name: "Reunification",
                _id: "Reunification",
              },
              {
                name: "Preservation",
                _id: "Preservation",
              },
            ]}
            value={data.DynamicFields.results.caseType}
          />
        </div>
        <div className="col">
          <Select
            name="region"
            label="Region"
            onChange={handleChange}
            options={[
              { name: "Central", _id: "Central" },
              { name: "East", _id: "East" },
              { name: "East Central", _id: "East Central" },
              { name: "Jefferson-Shelby", _id: "Jefferson-Shelby" },
              { name: "Northeast", _id: "Northeast" },
              { name: "Northwest", _id: "Northwest" },
              { name: "Southeast", _id: "Southeast" },
              { name: "Southwest", _id: "Southwest" },
              { name: "Tuscaloosa Hub", _id: "Tuscaloosa Hub" },
              { name: "West Central", _id: "West Central" },
            ]}
            value={data.DynamicFields.results.region}
          ></Select>
        </div>
        <div className="col"></div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="familyName"
            label="Family Name"
            onChange={handleChange}
            value={data.DynamicFields.results.familyName}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="caseNumber"
            label="Case Number"
            onChange={handleChange}
            value={data.DynamicFields.results.caseNumber}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="placementAtReferral"
            label="Placement at Referral"
            onChange={handleChange}
            value={data.DynamicFields.results.placementAtReferral}
          ></Input>
        </div>
      </div>
      <div className="row">
        <Input
          name="siblings"
          label="Siblings - Please include Name, SSN, DOB and Location (address) for each sibling"
          onChange={handleChange}
          value={data.DynamicFields.results.siblings}
        ></Input>
      </div>
      {/* <div className="row">
        <div className="col">
          <Input
            name="region"
            label="Region"
            onChange={handleChange}
            value={data.DynamicFields.results.region}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="modality"
            label="Modality"
            onChange={handleChange}
            value={data.DynamicFields.results.modality}
          ></Input>
        </div>
      </div> */}
      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default AlabamaIIHS;
